module.exports = __webpack_public_path__ + "static/media/rad2.1a0ec64c.svg";